import React, {useState} from 'react';
import Paper from '@material-ui/core/Paper/Paper';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import i18n from '../../i18n';
import {withStyles} from '@material-ui/core';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import {cleanPhone} from '../Form/utils';
import Query from 'react-apollo/Query';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import LinkIconButton from '../Formater/LinkIconButton';
import buildingQueries from '../../queries/buildingQueries';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import iconNames from '../Formater/IconNames';
import Button from '@material-ui/core/Button';
import RenderDetailsRow from '../Formater/RenderDetailsRow';
import moment from "moment";
import BuildingSubTable from "./BuildingSubTable";
import deficiencyQueries from "../../queries/deficiencyQueries";
import BuildingDeficienciesTable from "./BuildingDeficienciesTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";

const renderDetailsRow = (label, value, classes) => {

    let phone = value.landline ? (value.landline && value.mobile) : null;
    let email = value.email && value.email;

    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography
                        className={classes.detailsLabel}
                        component={'div'}
                        variant={'subtitle2'}>
                        {(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        className={classes.detailsValue}
                        component={'div'}
                        variant={'body2'}>
                        {(phone || email) ? value.first_name + ' ' + value.last_name : value}
                        {phone && (
                            <LinkIconButton
                                href={`tel:${cleanPhone(phone)}`}
                                text={phone}
                                icon={'phone'}
                                fontSize={'small'}
                                buttonProps={{style:{display: 'lowercase'}}}
                            />
                        )}
                        {email && (
                            <LinkIconButton
                                buttonProps={{style:{textTransform: 'lowercase'}}}
                                href={`mailto:${email}`}
                                text={email}
                                icon={'email'}
                                fontSize={'small'}
                            />
                        )}
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};


const BuildingDetails = ( props ) => {
    const {
        building,
        classes,
    } = props;

    //let classesButtonAble = {details: classes.details, detailsLabel: classes.detailsLabel};
    const superior = building.parent && building.parent.name;
    const builder = building.builder && building.company_name;
    const editor = building.editor && building.editor.name;
    const street = building.street + ' ' + building.number;
    const city = building.zip + ' ' + building.city;
    const acceptance = building.acceptance && moment( building.acceptance ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const start_of_construction = building.start_of_construction && moment( building.start_of_construction ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    const warranty_period_end = building.warranty_period_end && moment( building.warranty_period_end ,'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');


    const [searchValue, setSearchValue] = useState('');

    return (
        <React.Fragment>
            <Grid container spacing={24} className={classes.vSpace}>
                <Grid item sm={6}>
                    <Paper className={classes.spaces}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                <RenderDetailsRow label={i18n.get('building.construction_project')} value={ superior }>
                                    {building.parent && (
                                        <LinkIconButton
                                            text={superior}
                                            href={`/construction/${building.parent.id}`}
                                            icon={iconNames.building}
                                        />
                                    )}
                                </RenderDetailsRow>
                                {building.name && renderDetailsRow(i18n.get('building.form.name'), building.name , classes)}
                                {builder && renderDetailsRow(i18n.get('building.constructor'), builder , classes)}
                                {building.number_client && renderDetailsRow(i18n.get('building.form.number_client'), building.number_client , classes)}
                                {building.number_internal && renderDetailsRow(i18n.get('building.form.number_internal'), building.number_internal , classes)}
                                {acceptance && renderDetailsRow(i18n.get('building.form.acceptance'), acceptance , classes)}
                                {start_of_construction && renderDetailsRow(i18n.get('building.form.start_of_construction'), start_of_construction , classes)}
                                {warranty_period_end && renderDetailsRow(i18n.get('building.form.warranty_period_end'), warranty_period_end , classes)}
                                {street && renderDetailsRow(i18n.get('building.form.address'), street, classes)}
                                {city && renderDetailsRow('', city, classes)}
                            </List>
                        </div>
                    </Paper>
                </Grid>

                <Grid item sm={6}>
                    <Paper className={classes.spaces} style={{height:'100%'}}>
                        <div className={classes.details}>
                            <List className={classes.fullWidth}>
                                {editor && renderDetailsRow(i18n.get('building.form.editor'), editor, classes)}
                                {building.contact && renderDetailsRow(i18n.get('building.form.contact'), building.contact, classes)}
                            </List>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
            {building.parent ? (
                <React.Fragment>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} direction={'row'} alignItems={'flex-start'}>
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('deficiency.self_open')}</Typography>
                            </Grid>
                            <Grid item xs align={'right'}>
                                <Button size={"small"}
                                        variant={"contained"}
                                        href={`/project/create?building=${building.id}`}
                                        color={"primary"}
                                        style={{marginRight:10}}>
                                    <Icon fontSize="small">add</Icon>
                                    &nbsp;
                                    {i18n.get('deficiency.add')}
                                </Button>
                            </Grid>
                        </Grid>
                        <Query
                            query={deficiencyQueries.getDeficiencies}
                            variables={{building_id: building.id}}
                        >
                            {({loading, error, data}) => {
                                if (loading) {
                                    return <GraphQlLoading style={{margin:10}} />;
                                }
                                if (error) {
                                    return <GraphQlError style={{margin:10}} />;
                                }

                                if(data['findProjectsByBuilding']) {
                                    if( data['findProjectsByBuilding'].data.length > 0) {
                                        return <BuildingDeficienciesTable deficiencyBuildings={ data['findProjectsByBuilding'].data } />
                                    }
                                }
                                return <div>{i18n.get('default.empty')}</div>
                            }}
                        </Query>
                    </Paper>
                    <div className={classes.spaces}> </div>
                </React.Fragment>
            ) :(
                <React.Fragment>
                    <Paper className={classes.spaces}>
                        <Grid container spacing={24} justify="space-between" alignItems="center">
                            <Grid item xs>
                                <Typography variant="h6" color={"primary"}>{i18n.get('building.houses')}</Typography>
                            </Grid>
                            <Grid item xs={6} style={{padding:0}}>
                                <FormControl fullWidth className={classes.test}>
                                    <InputLabel htmlFor="standard-adornment-password">{i18n.get('building.search_for_deficiency')}</InputLabel>
                                    <Input
                                        id="search"
                                        name={'search'}
                                        type={'text'}
                                        value={searchValue}
                                        autoComplete={'off'}
                                        onChange={e => {
                                            setSearchValue(e.target.value);
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                {searchValue.length > 0 &&
                                                <IconButton
                                                    component={'span'}
                                                    size={'small'}
                                                    onClick={() => {
                                                        searchValue.length && setSearchValue( '');
                                                    }}
                                                >
                                                    <Icon>clear</Icon>
                                                </IconButton>
                                                }
                                                <IconButton
                                                    component={'span'}
                                                    size={'small'}
                                                    disabled
                                                    onClick={() => {
                                                        searchValue.length && setSearchValue( searchValue );
                                                    }}
                                                >
                                                    <Icon>search</Icon>
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs align={'right'}>
                                { (!building.completed && building.id && !building.parent_id) && (
                                    <Button size={"small"}
                                            variant={"contained"}
                                            href={`/construction/create?parent=${building.id}`}
                                            color={"primary"}
                                            style={{marginRight:10}}>
                                        <Icon fontSize="small">add</Icon>
                                        &nbsp;
                                        {i18n.get('building.add_house')}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                        <Query
                            query={buildingQueries.getSubordinates}
                            variables={{parent_id: building.id}}
                        >
                            {({loading, error, data}) => {

                                if (loading) {
                                    return <GraphQlLoading style={{margin:10}} />;
                                }
                                if (error) {
                                    return <GraphQlError style={{margin:10}} />;
                                }

                                return data.buildings && data.buildings.data.length > 0
                                    ? <BuildingSubTable buildings={data.buildings.data} detail={true} search={searchValue} />
                                    : <div>{i18n.get('default.empty')}</div>
                            }}
                        </Query>
                    </Paper>
                    <div className={classes.spaces}> </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );

}

const styles = theme => ({
    previewIcon: {
        textAlign: 'center',
    },
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: '100%',
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
    },
    detailsValue: {
        '& > *': {
            ...theme.helpers.oneLiner,
        },
    },
});

export default withStyles(styles)(BuildingDetails);
